import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import './index.scss';

import { getFullName } from '../../../services/userModel';

import { DATE_FORMAT, DATE_FORMAT_DMY_SHORT, getFormattedDate } from '../../../utils/convertTime';
import { CUSTOMER_WALLET_OPERATION_TYPE } from '../../../utils/constants';

import FormInfoDataItem from '../FormInfoDataItem';
import moment from "moment";
import Dropdown from "../Dropdown/index.js";
import { LOYALTY_LEVEL, WAITER_TYPES } from "../../../utils/enums.js";
import Waiter from "../Waiter/Waiter.jsx";
import { objectKeysToUpperLowerCase } from '../../../utils/objects-util.js';
import IconButton from '../IconButton/IconButton.jsx';
import { fixedNumber } from '../../../utils/math-util.js';

const CustomerDataHeader = ({ customerId, bonusCardLength, onBlockUser, filter, items, onOpenBonus, onSetFilter, isFetching, onUpdateLoyaltyLevel, onUpdateStaffComment, onClickBackButton, showBackButton }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(null);
  const [staffComment, setStaffComment] = useState('');

  useEffect(() => {
    const newUser = customerId && items?.find(f => f.ConsumerId === customerId);
    const newValue = newUser ? objectKeysToUpperLowerCase(newUser) : null;
    if ((!newValue || newValue?.consumerId === value?.consumerId) && isFetching) return;

    setValue(newValue);
    setStaffComment(newValue?.serviceNotes || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId, items, isFetching]);

  const handleOpenBonusCardsList = () => {
    onOpenBonus(CUSTOMER_WALLET_OPERATION_TYPE.bonusCardsList);
  };

  const handleOnChangeStaffComment = ({ target }) => setStaffComment(target.value);

  return (
    <div className={classNames('customerDataHeader')}>
      <div className={classNames('customerDataHeaderItem', 'controls')}>
        {showBackButton && (
          <div className={'controlItem'}>
            <IconButton isIcon iconName={'crossClose'} onClick={onClickBackButton} />
          </div>
        )}
        <div>{getFullName(value)}</div>
      </div>
      {value?.blockInfo?.isBlocked && (
        <div className={'customerDataHeaderItem blockInfo'}>
          <FormInfoDataItem title={t('customers.BLOCK_STATUS')} value={t('customers.BLOCKED_USER')} />
          <FormInfoDataItem title={t('customers.BLOCK_NOTE')} value={value.blockInfo.note} />
          <div className={'buttonControl'}>
            <Waiter
              type={WAITER_TYPES.span}
              spanText={t("customers.UNBLOCK_USER")}
              handleOnClick={() => onBlockUser(value)}
              useClass={"btn confirm"}
            />
          </div>
        </div>
      )}
      <div className={classNames('customerDataHeaderItem')}>
        {(value || {}).phone && (
          <FormInfoDataItem isNeverRtl={true} title={t('customers.PHONE_LABEL')} value={value?.phone} />
        )}
        <FormInfoDataItem title={t('customers.EMAIL_LABEL')} value={value?.email} />
        {value && value.birthdate && (
          <FormInfoDataItem title={t('customers.BDAY_LABEL')} value={moment(value.birthdate).format(DATE_FORMAT)} />
        )}
        {value && (
          <FormInfoDataItem hideTooltip title={t('customers.LOYALTY_LEVEL')} value={(
            <Dropdown
              values={Object.entries(LOYALTY_LEVEL).map(([key, value]) => ({ key: parseInt(key), value }))}
              value={LOYALTY_LEVEL[value.loyaltyLevel ?? 0]}
              onSelect={onUpdateLoyaltyLevel}
            />
          )} />
        )}
      </div>
      <div className={classNames('customerDataHeaderItem', 'regInfo')}>
        <FormInfoDataItem title={t('customers.WALLET_LABEL')} value={value?.wallet?.bonus || 0} />
        <FormInfoDataItem
          title={t('customers.AVERAGE_BILL_LABEL')}
          value={Number(parseFloat(value?.averageOrderAmount || 0).toFixed(2))}

        />
        <FormInfoDataItem
          title={t('customers.REGISTRATION_LABEL')}

          value={getFormattedDate(value?.creationDateTime, DATE_FORMAT_DMY_SHORT) || 0}
        />
        <FormInfoDataItem
          title={t('customers.REG_THROUGH_LABEL')}
          value={value?.registrationSources.join(', ') || ''}

        />
      </div>
      <div className={classNames('customerDataHeaderItem', 'regInfo')}>
        <FormInfoDataItem title={t('customers.TOTAL_SPENT')} value={fixedNumber(value?.totalAmountSpent || 0, 2)} />
        <FormInfoDataItem
          onClick={value?.wallet?.bonusCards?.length && handleOpenBonusCardsList}
          title={t('customers.VOUCHERS')}
          value={value?.wallet?.bonusCards?.length || 0}

        />
        <FormInfoDataItem
          title={t('customers.TOTAL_CARD_PAYMENTS')}
          value={value?.totalCardPayments || 0}

        />
        <FormInfoDataItem
          title={t('customers.TOTAL_CASH_PAYMENTS')}
          value={value?.totalCashPayments || 0}

        />
        <FormInfoDataItem title={t('customers.TOTAL_ORDERS')} value={value?.totalOrders || 0} />
      </div>
      <div className={classNames('customerDataHeaderItem', 'regInfo', 'staffComment')}>
        <FormInfoDataItem hideTooltip title={t('customers.STAFF_ONLY_COMMENT')} value={
          <input
            type="text"
            value={staffComment}
            onChange={handleOnChangeStaffComment}
          />
        } />
        <div className={'buttonControl'}>
          <Waiter
            type={WAITER_TYPES.span}
            spanText={t("customers.STAFF_ONLY_COMMENT_UPDATE")}
            handleOnClick={() => onUpdateStaffComment(staffComment)}
            useClass={"btn confirm"}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  items: state?.order?.data?.customTableConfigPagination?.customerServiceCustomers?.orders?.Page || [],
});

export default connect(mapStateToProps)(CustomerDataHeader);
